// extracted by mini-css-extract-plugin
export default {"titleBlock":"BlockResume_titleBlock__sEn8z","blockResume":"BlockResume_blockResume__b9pwi","description":"BlockResume_description__rrqn0"};